// `?step=` value that opens SignInCard on the "Forgot password?" request form.
export const FORGOT_PASSWORD_STEP = 'forgot-password';

// Mirrors PASSWORD_RESET_TOKEN_TTL_MINUTES on the backend.
export const PASSWORD_RESET_LINK_TTL_MINUTES = 10;
